import { Component } from '@angular/core';
import { FilterUIModel } from '../Filters/filterUI.model';
import { AgGridYesNoFilterComponent } from '../Filters/YesNo/agGridYesNoFilter.component';
import { WSFloatingFilterParams } from './agGridFloatingFilterBase';
import { IFilterOptionDef } from 'ag-grid-community';

@Component({
    selector: 'yes-no-floating-filter-component',
    template: `
        @if (!conditionApplied) {
          <select
            [ngModel]="value"
            (ngModelChange)="valueChange($event)">
            @for (option of filterOptions; track option) {
              <option [ngValue]="option">{{option.displayName}}</option>
            }
          </select>
        }
        @if (conditionApplied) {
          <div>
            <span>{{ conditionValues }}</span>
          </div>
        }
        `,
    styleUrls: ['./agGridFloatingFilter.scss'],
    host: { 'class': 'ag-input-wrapper' },
    standalone: false
})
export class AgGridYesNoFloatingFilterComponent {
    value: IFilterOptionDef;
    type: string;
    conditionApplied: boolean;
    filterOptions: IFilterOptionDef[] = [];
    conditionValues: string;

    protected _params: WSFloatingFilterParams;

    agInit(params: WSFloatingFilterParams): void {
        this._params = params;
        this.value = params.filterParams['defaultOption'];

        // This property exists but isn't on the model for some reason
        // Bracket notation bypasses the typechecking
        this.filterOptions = params.filterParams['filterOptions'];
    }

    valueChange(filterType: IFilterOptionDef): void {
        this.value = filterType;
        const type = this.value.displayKey;
        
        // For blank/notBlank operators, there is no filter value
        const valueToUse = (type === 'blank' || type === 'notBlank') ? '' : this.value.displayName;
        
        this._params.parentFilterInstance((instance) => (instance as unknown as AgGridYesNoFilterComponent).onFloatingFilterChanged(type, valueToUse, true));
    }

    onParentModelChanged(parentModel: FilterUIModel): void {
        this.value = null;
        this.type = this._params.filterParams['defaultOption'];
        if (parentModel && parentModel.filterConditionType) {
            this.conditionValues = parentModel.filterValues.map(x => `${x.filterType.displayName}`)
                .join(parentModel.filterConditionType === Core.FilterConditionTypeEnum.And ? ' AND ' : ' OR ');
            this.conditionApplied = true;
        } else {
            this.value = parentModel && parentModel.filterValues[0] && parentModel.filterValues[0].filterType;
            this.type = parentModel && parentModel.filterValues[0] && parentModel.filterValues[0].filterType.displayKey;
            this.conditionApplied = false;
        }
    }

}
